import { Page } from "../layout/page";
import { Accordion, Title, Tabs, Text } from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { REPORT_CATEGORIES } from "../data/reportCategories";

const Report = ({}) => {
  const { t } = useTranslation();

  const renderReportAccordion = (reports) => (
    <Accordion
      variant="separated"
      radius="xs"
      defaultValue="customization"
      mt={"md"}
    >
      {reports.map((r) => (
        <Accordion.Item key={r.title} value={r.title}>
          <Accordion.Control>
            <Title order={5}>{t(r.title)}</Title>
            {r.subtitle && (
              <Text size="sm" color="dimmed">
                {t(r.subtitle)}
              </Text>
            )}
          </Accordion.Control>
          <Accordion.Panel>
            <r.reportComponent />
          </Accordion.Panel>
        </Accordion.Item>
      ))}
    </Accordion>
  );

  return (
    <Page title={t("Report")}>
      <Tabs variant="default" defaultValue="orders">
        <Tabs.List>
          {REPORT_CATEGORIES.map((category) => (
            <Tabs.Tab key={category.id} value={category.id}>
              {t(category.label)}
            </Tabs.Tab>
          ))}
        </Tabs.List>

        {REPORT_CATEGORIES.map((category) => (
          <Tabs.Panel key={category.id} value={category.id} pt="xl">
            {renderReportAccordion(category.reports)}
          </Tabs.Panel>
        ))}
      </Tabs>
    </Page>
  );
};

export default Report;
